<template>
  <div class="checkitem">
    <div ref="headbox" class="checkitem-head">
      <div class="checkitem-head-bottle">{{ index }}</div>
      <el-input
        v-model="model.content"
        :placeholder="model.type!=='edit'?'':$t('checkList.pleaseInsertExplain')"
        class="checkitem-head-input"
        type="textarea"
        autosize
        v-if="model.type==='edit'"
      />
      <div
        style="margin-left:20px;flex-grow:1;width:0;line-height:24px;font-size:14px;"
        v-if="model.type!=='edit'"
      >{{model.content}}</div>
    </div>
    <div class="checkitem-link-input-box">
      <!-- <el-input
        v-model="model.link"
        :placeholder="model.type!=='edit'?'':$t('checkList.pleaseInsertLink')"
        type="textarea"
        autosize
        v-if="model.type==='edit'"
      />-->
    </div>
    <div class="checkitem-bottom">
      <div class="checkitem-bottom-filelink">
        <uploadlist
          v-if="model.type==='edit'||model.fileList.length>0"
          :type="model.type==='edit'?'edit':'view'"
          :file-list="model.fileList"
        >
          <div
            v-if="model.type==='edit'||model.fileList.length>0"
            class="file-lable"
          >{{ $t("checkList.generalAttachment") }}</div>
        </uploadlist>
        <div class="linkbox">
          <div>
            <cus-btn
              v-if="model.type==='edit'"
              style="margin-bottom:20px;"
              type="addLink"
              @click="openLinkDialog"
            ></cus-btn>
            <template>
              <div
                v-for="(item,index) in model.linkList"
                :key="index"
                class="link"
                @click="openWebPage(item.hyperlink)"
              >{{item.linkName}}</div>
            </template>
          </div>
        </div>
      </div>
      <div v-if="model.isSchedule&&model.type.indexOf('answer')!==-1">
        {{ $t("checkList.schedule") }}
        <el-date-picker
          :readonly="model.type=='answerview'"
          style="margin-left:10px;"
          v-model="model.schedule"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
        ></el-date-picker>
      </div>
      <div v-if="model.type.indexOf('edit')===-1" class="checkitem-bottom-radio">
        <el-radio-group v-model="model.status">
          <el-radio :label="0" :disabled="model.type!=='answer'">{{ $t('checkList.inProgress') }}</el-radio>
          <el-radio :label="1" :disabled="model.type!=='answer'">{{ $t('checkList.done') }}</el-radio>
          <el-radio :label="2" :disabled="model.type!=='answer'">{{ $t('checkList.na') }}</el-radio>
        </el-radio-group>
      </div>

      <div v-if="model.type.indexOf('edit')!==-1" class="attachments-box">
        <el-checkbox
          v-model="model.isNeedAttachments"
          :disabled="model.type!=='edit'"
        >{{ $t('checkList.attachments') }}</el-checkbox>
        <el-checkbox
          v-model="model.isSchedule"
          :disabled="model.type!=='edit'"
        >{{ $t('checkList.schedule') }}</el-checkbox>
      </div>

      <uploadlist
        v-if="model.isNeedAttachments&&model.type.indexOf('answer')!==-1"
        :type="model.type==='answer'?'edit':'view'"
        :file-list="model.answerfileList"
      >
        <div
          v-if="model.isNeedAttachments&&(model.type==='answer'||(model.type==='answerview'&&model.answerfileList.length>0))"
          class="file-lable"
        >{{ $t("checkList.projectAttachment") }}</div>
      </uploadlist>
    </div>
    <el-dialog
      :title="$t('checkList.addLink')"
      :visible.sync="linkAddDialog"
      width="800px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="linkform" :model="ruleForm">
        <el-table
          :data="ruleForm.tableLinkList"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="{
        background: 'rgba(245,246,250,1)',
        lineHeight: '23px',
        color: '#232323'
      }"
        >
          <el-table-column
            type="index"
            :label="$t('formData.no')"
            header-align="center"
            align="center"
            width="80px"
          ></el-table-column>
          <el-table-column
            :label="$t('checkList.linkName')"
            header-align="center"
            prop="linkName"
            width="200px"
          >
            <template slot-scope="scope">
              <el-form-item
                :rules="linkDataRule.linkName"
                :prop="`tableLinkList.${scope.$index}.linkName`"
                style="width:100%;margin-top:14px;"
              >
                <el-input v-model="scope.row.linkName"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('checkList.hyperlink')"
            header-align="center"
            prop="hyperlink"
            min-width="400px"
          >
            <template slot-scope="scope">
              <el-form-item
                :rules="linkDataRule.hyperlink"
                :prop="`tableLinkList.${scope.$index}.hyperlink`"
                style="width:100%;margin-top:14px;"
              >
                <el-input v-model="scope.row.hyperlink"></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            width="80px"
            :label="$t('formData.action')"
            header-align="center"
            align="center"
          >
            <template slot="header">
              <div class="table-action" @click="addLink()">
                <img src="../../assets/checklist/add.png" />
              </div>
            </template>
            <template slot-scope="scope">
              <div class="table-action" @click="removeLink(scope.row)">
                <img src="../../assets/checklist/remove.png" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <cus-btn type="cancel" @click="linkAddDialog = false"></cus-btn>
        <cus-btn type="save" @click="saveLink"></cus-btn>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import uploadlist from "./uploadlist";
import download from "@/utils/downloadCustom";
import { fileInfo, fileDownloadByInnerUrl } from "@/api/templateManagement";
export default {
  components: {
    uploadlist: uploadlist
  },
  props: {
    index: {
      type: Number,
      default: null
    },
    model: {
      type: Object,
      default: () => {
        return {
          id: null,
          content: "",
          type: "",
          changeStatus: "new",
          isNeedAttachments: false,
          isSchedule: false,
          fileList: [],
          status: 0,
          answerfileList: [],
          link: "",
          schedule: "",
          linkList: []
        };
      }
    }
  },
  data() {
    return {
      linkAddDialog: false,
      linkData: {
        linkName: "",
        hyperlink: ""
      },
      ruleForm: {
        tableLinkList: []
      }
    };
  },
  computed: {
    urlList() {
      if (this.model.link) {
        let temp = this.model.link.replace(/；/g, ";");
        return temp.split(";");
      }
      return [];
    },
    linkDataRule() {
      return {
        linkName: [
          {
            required: true,
            message: this.$t("checkList.pleaseInsertLinkName"),
            trigger: "blur"
          },
          {
            min: 1,
            max: 250,
            message: this.$t("messageCommon.lengthSectionFormatter", [
              "1",
              "250"
            ]),
            trigger: "blur"
          }
        ],
        hyperlink: [
          {
            required: true,
            message: this.$t("checkList.pleaseInsertHyperlink"),
            trigger: "blur"
          },
          {
            min: 1,
            max: 250,
            message: this.$t("messageCommon.lengthSectionFormatter", [
              "1",
              "250"
            ]),
            trigger: "blur"
          }
        ]
      };
    }
  },
  watch: {},
  created() {
    if (!this.model.linkList) {
      this.model.linkList = [];
    }
  },
  mounted() {},
  methods: {
    openWebPage(url) {
      if (url) {
        if (url.toLowerCase().indexOf("file") === 0) {
          // fileInfo({ fileShowUrl: url }).then(res => {
          //   if (res.code == 200) {
          //     const loading = this.$loading({
          //       lock: true,
          //       text: this.$t("checkList.downloading")
          //     });
          //     fileDownloadByInnerUrl(url).then(resp => {
          //       download.downloadByStream(resp, res.data.fileName);
          //       loading.close();
          //     }).catch(()=>{
          //       loading.close();
          //     });
          //   }
          // });
          window.open('/#/pdfpreview?file='+url)
        } else {
          window.open(url);
        }
      }
    },
    openLinkDialog() {
      this.linkAddDialog = true;
      this.ruleForm.tableLinkList = JSON.parse(
        JSON.stringify(this.model.linkList)
      );
      if (this.ruleForm.tableLinkList.length == 0) {
        this.ruleForm.tableLinkList.push({
          linkName: "",
          hyperlink: ""
        });
      }
      this.$nextTick(() => {
        this.$refs.linkform.clearValidate();
      });
    },
    saveLink() {
      this.$refs.linkform.validate((result, valobj) => {
        if (result) {
          this.model.linkList = JSON.parse(
            JSON.stringify(this.ruleForm.tableLinkList)
          );
          this.linkAddDialog = false;
        }
      });
    },
    addLink() {
      this.ruleForm.tableLinkList.push({
        linkName: "",
        hyperlink: ""
      });
    },
    removeLink(link) {
      this.ruleForm.tableLinkList.splice(
        this.ruleForm.tableLinkList.indexOf(link),
        1
      );
    }
  }
};
</script>
<style lang="scss"  scoped >
.checkitem {
  flex-shrink: 0;
  flex-grow: 1;
}
.checkitem-head {
  display: flex;
  align-items: flex-start;
  /* margin-bottom: 20px; */
}
.checkitem-head-bottle {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  background-image: url("../../assets/checklist/bottle.png");
  background-size: 100% 100%;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  box-sizing: border-box;
  padding-bottom: 2px;
}
.checkitem-head-input {
  margin-left: 20px;
}
.checkitem-link-input-box {
  padding-left: 50px;
  margin-top: 15px;
}
.checkitem-bottom {
  box-sizing: border-box;
  padding-left: 56px;
}
.checkitem-bottom > div {
  margin-top: 15px;
}
.attachments-box {
  margin-top: 20px;
}

.file-lable {
  margin-top: 10px;
  font-size: 14px;
  color: rgba(35, 35, 35, 1);
}
.checkitem-bottom-filelink {
  display: flex;
  margin-left: 10px;
  .linkbox {
    flex-grow: 1;
    margin-left: 20px;
  }
}
.checkitem-bottom-filelink > div:nth-child(1) {
  min-width: 300px;
}
.checkitem-bottom-filelink > div {
  flex-shrink: 0;
}
.link {
  line-height: 14px;
  font-size: 14px;
  color: #4a90e2;
  cursor: pointer;
  margin-bottom: 8px;
}
.link-container {
  display: flex;
  .link {
    flex-grow: 1;
    flex-shrink: 0;
  }
  .link-remove {
    flex-shrink: 0;
  }
}
.table-action {
  height: 23px;
  line-height: 23px;
  display: block !important;
  img {
    height: 22px;
    width: 22px;
    cursor: pointer;
  }
}
</style>

